import { render, staticRenderFns } from "./SignupDataReview.vue?vue&type=template&id=95524e80"
import script from "./SignupDataReview.vue?vue&type=script&lang=js"
export * from "./SignupDataReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports